const feedbackActionTypes = {
  FEEDBACK_SITE_START: 'FEEDBACK_SITE_START',
  FEEDBACK_SITE_SUCCESS: 'FEEDBACK_SITE_SUCCESS',
  FEEDBACK_SITE_FAIL: 'FEEDBACK_SITE_FAIL',
  CLEAR_MESSAGE: 'CLEAR_MESSAGE',
};

export default feedbackActionTypes;
